import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'

import { Button } from 'components'
import { useValueContext } from 'contexts'
import { isBeforeCurrent } from 'utils'

import './styles.scss'

export const CurrentFooter = observer(() => {
  const { eventStore } = useValueContext()
  const { event, loading, saveCurrent } = eventStore
  const navigate = useNavigate()

  const hasError = !isBeforeCurrent(event.startTime)

  const onEditEvent = async () => {
    const result = await saveCurrent()

    if (result) {
      navigate('/home')
    }
  }

  return (
    <div className="event-footer">
      <Button width="100%" disabled={hasError || loading} onClick={onEditEvent}>
        Сохранить изменения
      </Button>
    </div>
  )
})
